module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', [_c('a', {
    staticClass: "back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goBack($event)
      }
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Rangliste")])]), _vm._v(" "), _c('section', [_c('header', [_c('div', {
    staticClass: "choice"
  }, [_c('router-link', {
    class: {
      'btn-secondary': _vm.$route.params.type == 'global'
    },
    attrs: {
      "to": ("/users/" + _vm.userId + "/ranking/global"),
      "replace": ""
    }
  }, [_vm._v("\n                    Weltweit\n                ")]), _vm._v(" "), (_vm.who.city) ? _c('router-link', {
    class: {
      'btn-secondary': _vm.$route.params.type == 'city'
    },
    attrs: {
      "to": ("/users/" + _vm.userId + "/ranking/city"),
      "replace": ""
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.who.city.name) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    class: {
      'btn-secondary': _vm.$route.params.type == 'friends'
    },
    attrs: {
      "to": ("/users/" + _vm.userId + "/ranking/friends"),
      "replace": ""
    }
  }, [_vm._v("\n                    Freunde\n                ")]), _vm._v(" "), (_vm.who.year) ? _c('router-link', {
    class: {
      'btn-secondary': _vm.$route.params.type == 'year'
    },
    attrs: {
      "to": ("/users/" + _vm.userId + "/ranking/year"),
      "replace": ""
    }
  }, [_vm._v("\n                    " + _vm._s(_vm._f("grade")(_vm.who.year)) + ". Klasse\n                ")]) : _vm._e(), _vm._v(" "), (_vm.who.school) ? _c('router-link', {
    class: {
      'btn-secondary': _vm.$route.params.type == 'school'
    },
    attrs: {
      "to": ("/users/" + _vm.userId + "/ranking/school"),
      "replace": ""
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.who.school.name) + "\n                ")]) : _vm._e()], 1)]), _vm._v(" "), _c('ol', {
    staticClass: "ranking"
  }, _vm._l((_vm.ranking), function(player) {
    return _c('li', {
      class: {
        highlight: player.id == _vm.userId
      }
    }, [_c('router-link', {
      staticClass: "item",
      attrs: {
        "to": ("/profile/" + (player.id))
      }
    }, [_c('dp', {
      attrs: {
        "who": player
      }
    }), _vm._v(" "), (player.rank_prev !== null && player.rank_prev > player.rank) ? _c('div', {
      staticClass: "rank-change"
    }, [_vm._v("\n                        " + _vm._s(player.rank_prev - player.rank) + " ⬆️\n                    ")]) : _vm._e(), _vm._v(" "), (player.rank_prev !== null && player.rank_prev < player.rank) ? _c('div', {
      staticClass: "rank-change"
    }, [_vm._v("\n                        " + _vm._s(player.rank - player.rank_prev) + " ⬇️\n                    ")]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v("\n                        " + _vm._s(_vm._f("name")(player)) + "\n                    ")]), _vm._v(" "), _c('p', {
      staticClass: "elo"
    }, [_vm._v("\n                        ELO: " + _vm._s(player.elo) + "\n                    ")])], 1)], 1)
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-915d8b30","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ranking.vue
// module id = 237
// module chunks = 0